import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FormSubmitButtonComponent } from '../../../ui/forms/form-submit-button/form-submit-button.component';
import { TextareaFieldComponent } from '../../../fields/standard/textarea-field/textarea-field.component';
import { FieldLabelComponent } from '../../../ui/forms/field-label/field-label.component';

@Component({
	selector: 'app-emails-form',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		FormSubmitButtonComponent,
		TextareaFieldComponent,
		FieldLabelComponent,
	],
	templateUrl: './emails-form.component.html',
	styleUrl: './emails-form.component.scss',
})
export class EmailsFormComponent {
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();

	public form: FormGroup = this.fb.group({
		emails: ['', TextareaFieldComponent.validators],
	});

	constructor(private fb: FormBuilder) {}

	public onSubmit() {
		this.onSubmitEmitter.emit(this.form.value);
	}
}
